import React, { Component } from 'react';
import './Account.css'
import './SideNav.css'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl';
import { Avatar, Typography, Divider } from 'antd';
import {
    DashboardOutlined,
    UserOutlined,
    UnorderedListOutlined,
    LockOutlined,
    QuestionCircleOutlined,
    ShoppingOutlined,
    LogoutOutlined,
    CloseOutlined
} from '@ant-design/icons';
import { GET_USER_STAT_URL, get_data_token } from '../../config/network';

const { Text } = Typography;

class SideNav extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this.state = {
            memberProfile: {
                firstName: '',
                lastName: ''
            }
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.loadUserProfile();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    loadUserProfile = () => {
        if (localStorage.getItem('accessToken')) {
            get_data_token(GET_USER_STAT_URL, {})
                .then(data => {
                    if (!this._isMounted) return;
                    this.setState({
                        memberProfile: data.profile || {
                            firstName: '',
                            lastName: ''
                        }
                    });
                })
                .catch(err => {
                    console.error('Failed to load user profile:', err);
                });
        }
    }

    getRootClass() {
        if (this.props.sidenav_show === true) {
            return "sidenav sidenave-show";
        }
        else return "sidenav";
    }
    // render_recharge() {
    //     if (process.env.REACT_APP_LOCATION === 'CHINESE') return;
    //     return (
    //         <div>
    //             <Link className={this.props.page === 'Recharge' ? "current" : null} to="/account/recharge"><i class="fa fa-dollar"></i>
    //                 {' '} <FormattedMessage id="page.sidnav.title.Recharge" defaultMessage="Recharge" />

    //             </Link>
    //             <Link className={this.props.page === 'RechargeRecords' ? "current" : null} to="/account/rechargerecords"><i class="fa fa-list"></i>
    //                 {' '} <FormattedMessage id="page.sidnav.title.RechargeRecords" defaultMessage="Recharge Records" />
    //             </Link>
    //         </div>
    //     )
    // } 
    render() {
        let isprofile = localStorage.getItem('isProfileCompleted');
        // Allow navigation if profile is completed OR if user has an access token (is logged in)
        const hasAccess = (isprofile === '1') || localStorage.getItem('accessToken');
        const selectedKey = this.getSelectedKey();

        const menuItems = [
            {
                key: 'dashboard',
                to: '/account/dashboard',
                icon: <DashboardOutlined />,
                messageId: 'page.sidnav.title.Dashboard',
                defaultMessage: 'Dashboard'
            },
            {
                key: 'profile',
                icon: <UserOutlined />,
                to: '/account/profile',
                messageId: 'page.sidnav.title.Profile',
                defaultMessage: 'Profile'
            },
            {
                key: 'transactions',
                icon: <UnorderedListOutlined />,
                to: '/account/Transactions',
                messageId: 'page.sidnav.title.Transactions',
                defaultMessage: 'Transactions'
            },
            {
                key: 'changepassword',
                icon: <LockOutlined />,
                to: '/account/changepassword',
                messageId: 'page.sidnav.title.ChangePassword',
                defaultMessage: 'Change Password'
            },
            {
                key: 'support',
                icon: <QuestionCircleOutlined />,
                to: '/account/support',
                messageId: 'page.sidnav.title.Support',
                defaultMessage: 'Support'
            },
            {
                key: 'product',
                icon: <ShoppingOutlined />,
                to: '/productselect',
                messageId: 'page.product',
                defaultMessage: 'Rent Product'
            }
        ];

        if (hasAccess) {
            return (
                <div className={this.getRootClass()}>
                    {/* Header */}
                    <div className="modern-side-header">
                        <Link to="/" className="brand-link">
                            <img
                                alt="ZipcodeXpress"
                                className="modern-brand-img"
                                src={require("../../img/zipcodexpress_logo.png")}
                            />
                        </Link>
                        {this.props.sidenav_show === true && (
                            <CloseOutlined
                                className="modern-closebtn"
                                onClick={this.props.toggle}
                            />
                        )}
                    </div>

                    <Divider style={{ margin: '16px 0', borderColor: '#434343' }} />

                    {/* User Info */}
                    <div className="modern-user-info">
                        <Avatar
                            size={48}
                            icon={<UserOutlined />}
                            style={{ backgroundColor: '#1890ff' }}
                        />
                        <div className="user-details">
                            <Text className="user-name">
                                {this.state.memberProfile.firstName
                                    ? `${this.state.memberProfile.firstName} ${this.state.memberProfile.lastName}`.trim()
                                    : 'Welcome Back'
                                }
                            </Text>
                            <Text className="user-role" type="secondary">
                                {this.state.memberProfile.firstName ? 'Member' : 'Please complete profile'}
                            </Text>
                        </div>
                    </div>

                    <Divider style={{ margin: '16px 0', borderColor: '#434343' }} />

                    {/* Navigation Menu */}
                    <div className="modern-menu">
                        {menuItems.map(item => (
                            <Link
                                key={item.key}
                                to={item.to}
                                className={`modern-menu-item ${selectedKey === item.key ? 'modern-menu-item-selected' : ''}`}
                            >
                                <span className="modern-menu-icon">{item.icon}</span>
                                <span>
                                    <FormattedMessage id={item.messageId} defaultMessage={item.defaultMessage} />
                                </span>
                            </Link>
                        ))}
                    </div>

                    {/* Logout at bottom */}
                    <div className="modern-logout">
                        <Link to="/logout" className="logout-menu" style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8, padding: '12px 24px' }}>
                            <LogoutOutlined />
                            <FormattedMessage id="page.logout" defaultMessage="Logout" />
                        </Link>
                    </div>
                </div>
            );
        }

        //未完善信息
        return (
            <div className={this.getRootClass()}>
                {/* Header */}
                <div className="modern-side-header">
                    <Link to="/" className="brand-link">
                        <img
                            alt="ZipcodeXpress"
                            className="modern-brand-img"
                            src={require("../../img/zipcodexpress_logo.png")}
                        />
                    </Link>
                    {this.props.sidenav_show === true && (
                        <CloseOutlined
                            className="modern-closebtn"
                            onClick={this.props.toggle}
                        />
                    )}
                </div>

                <Divider style={{ margin: '16px 0', borderColor: '#434343' }} />

                {/* Limited Navigation for incomplete profiles */}
                <div className="modern-menu">
                    <Link
                        to="/account/profile"
                        className={`modern-menu-item ${selectedKey === 'profile' ? 'modern-menu-item-selected' : ''}`}
                    >
                        <span className="modern-menu-icon"><UserOutlined /></span>
                        <span>
                            <FormattedMessage id="page.sidnav.title.Profile" defaultMessage="Complete Profile" />
                        </span>
                    </Link>
                </div>

                {/* Logout at bottom */}
                <div className="modern-logout">
                    <Link to="/logout" className="logout-menu" style={{ color: 'inherit', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8, padding: '12px 24px' }}>
                        <LogoutOutlined />
                        <FormattedMessage id="page.logout" defaultMessage="Logout" />
                    </Link>
                </div>
            </div>
        );

    }

    getSelectedKey() {
        // Map page props to menu keys
        const pageKeyMap = {
            'Account': 'dashboard',
            'Profile': 'profile',
            'Transactions': 'transactions',
            'ChangePassword': 'changepassword',
            'Support': 'support',
            'Product': 'product'
        };
        return pageKeyMap[this.props.page] || 'dashboard';
    }
}

export default SideNav;